import { history } from 'umi';
// import { stringify } from 'querystring';
import { ssoLogin } from '@/services/login';

import { SSO_PATH } from '../config/'


export function render(oldRender: () => void) {

  console.log('LQ_DEV === ', process.env.LQ_DEV)
  if (history.location.query && history.location.query.satoken) {
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem('saToken', history.location.query.satoken as string);
    
    ssoLogin({ satoken: history.location.query.satoken as string }).then(res => {
      
      if(res.data && res.data.token) {
        localStorage.setItem("sToken", res.data.token);
        history.replace('/gameSelect');
        oldRender()
      }

    })

  } else if (localStorage.getItem('sToken')) {
    oldRender()
  } else {
    window.location.href = `${SSO_PATH}/login?targetUrl=${window.location.origin}`
  }

}
